import { SVButton, SVSSNInput, SVTextInput } from '@/components/core';
import { blankBeneficiary } from '@/constants/bankAccountApplications';
import { REGEX } from '@/constants/regex';
import { BankApplicationFormValues } from '@/types/bankApplications';
import { Delete } from '@mui/icons-material';
import { Card, Grid, IconButton, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';

export default function BankAccountApplicationBeneficiaries() {
  const formMethods = useFormContext<BankApplicationFormValues>();
  const { control, watch } = formMethods;
  const { fields, append, remove } = useFieldArray<BankApplicationFormValues>({
    control,
    name: 'beneficiaries' as const,
  });
  const beneficiaries = watch('beneficiaries');

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Beneficiaries (Optional)
      </Typography>
      {fields.map((item, index) => (
        <Grid
          container
          data-testid={`beneficiaryRow${index}`}
          key={item.id}
          spacing={2}
          sx={{ alignItems: 'center' }}>
          <Grid size={{ xs: 12, md: 3 }}>
            <SVTextInput
              name={`beneficiaries.${index}.firstName`}
              label="First Name"
              rules={{ required: true }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <SVTextInput
              name={`beneficiaries.${index}.lastName`}
              label="Last Name"
              rules={{ required: true }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <SVSSNInput
              name={`beneficiaries.${index}.tin`}
              label="Social Security Number"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <SVTextInput
              name={`beneficiaries.${index}.percentOfAllocation`}
              label="Allocation Percentage"
              inputProps={{ endAdornment: <Typography>%</Typography> }}
              rules={{
                required: true,
                pattern: {
                  regex: REGEX.DECIMAL_NUMBER,
                  readablePatternName: 'percentage',
                },
                max: 100,
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 1 }}>
            <IconButton
              data-testid={`membersRowDelete${index}`}
              sx={{ alignSelf: 'flex-start' }}
              onClick={() => remove(index)}>
              <Delete />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      {beneficiaries.length <= 3 && (
        <SVButton variant="outlined" onClick={() => append(blankBeneficiary)}>
          Add Beneficiary
        </SVButton>
      )}
    </Card>
  );
}
